var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('AcquisitionEditStyled', [_c('header', [_vm._v(_vm._s(_vm.$t('actions.updateAcquisition')))]), _c('AcquisitionManageMolecule', {
    attrs: {
      "isLoading": false,
      "selectedOrganization": _vm.selectedOrganization,
      "selectedProduct": _vm.selectedProduct,
      "selectedProductTier": _vm.selectedProductTier,
      "selectedAcquisitionType": _vm.selectedAcquisitionType,
      "organizations": _vm.organizations,
      "productsAvailable": _vm.productsAvailable,
      "productsTierAvailable": _vm.productsTierAvailable,
      "acquisitionsTypes": _vm.acquisitionsTypes,
      "productsTierNotAvailable": _vm.productsTierNotAvailable
    },
    on: {
      "update:selectOrganization": function updateSelectOrganization(org) {
        _vm.selectedOrganizationId = org.id;
      },
      "update:selectProduct": function updateSelectProduct(p) {
        _vm.selectedProductId = p.id;
      },
      "update:selectProductTier": function updateSelectProductTier(t) {
        _vm.selectedProductTierId = t.id;
      },
      "update:selectAcquisitionType": function updateSelectAcquisitionType($event) {
        _vm.selectedAcquisitionType = $event;
      }
    }
  }), _c('div', {
    staticClass: "action"
  }, [_c('Button', {
    attrs: {
      "label": _vm.$t('actions.updateAcquisition'),
      "disabled": !_vm.selectedOrganization || !_vm.selectedProduct || !_vm.selectedProductTier
    },
    on: {
      "click": _vm.confirmUpdateAcquisition
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }